
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface HeroSectionProps {
  isVisible: boolean;
}

const HeroSection = ({ isVisible }: HeroSectionProps) => {
  const isMobile = useIsMobile();
  
  return (
    <section className="pt-16 pb-8 sm:pt-20 sm:pb-10 md:pt-24 md:pb-12 px-4 sm:px-6 lg:px-8 bg-secondary/5">
      <div className="max-w-5xl mx-auto text-center">
        <h1 
          className={cn(
            "text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-5 md:mb-6 transition-all duration-700",
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          )}
        >
          Contact Us
        </h1>
        <p 
          className={cn(
            "text-base sm:text-lg md:text-xl text-muted-foreground max-w-xs sm:max-w-md md:max-w-xl mx-auto transition-all duration-700 delay-200",
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          )}
        >
          We're here to help with your project needs. Get in touch with our team.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
